<template>
  <div class="ty-main">
    <div class="ty-tip">
      <div class="ty-img">
        <img src="../assets/images/prompt.png" />
      </div>

      <div class="tip">
        开启会话共享后，开通会话存档的员工，可以将聊天记录共享给其他添加该客户的员工
      </div>
    </div>
    <div class="ty-card"  style="height:80px;">
      <div class="ty-tab">
        <!--          v-auth="[item.auth]"-->
        <div
          class="tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ active: tabIndex === index }"
          @click="tabChange(index)"
        >{{ item.title }}
        </div>
      </div>
    </div>
    <div class="ty-cha" :class="display_status2">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent>
        <el-form-item label="客户名称:">
          <el-input
            v-model="searchForm.clientName"
            placeholder="请输入客户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="跟进员工:">
        <el-input
          v-model="searchForm.st_user_id"
          placeholder="请选择员工"
          @focus="openSelectDialog"
          clearable
          @clear="employeeClear"
        ></el-input>
        </el-form-item>
        <el-form-item :class="display_status"  label="共享状态:">
          <el-select v-model="searchForm.share_status"  placeholder="请选择">
            <el-option
            v-for="item in options"
            :key="item.share_status"
            :label="item.label"
            :value="item.share_status"
            clearable />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" style="margin-bottom: 20px;" @click="onSearch" :disabled="disabledButton">查询</el-button>
        </el-form-item>
          <el-button :class="display_status" class="fr" type="info" plain @click="kai" :disabled="disabledButton">批量操作</el-button>
      </el-form>
    </div>

    <div class="ty-cha" :class="display_status3">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent>
        <el-form-item label="客户名称:">
          <el-input
            v-model="searchForm.clientName"
            placeholder="请输入客户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="跟进员工:">
          <el-input
            v-model="searchForm.st_user_id"
            placeholder="请选择员工"
            @focus="openSelectDialog"
            clearable
            @clear="employeeClear"
          ></el-input>
        </el-form-item>
        <el-form-item :class="display_status"  label="共享状态:">
          <el-select v-model="searchForm.share_status"  placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.share_status"
              :label="item.label"
              :value="item.share_status"
              clearable />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" style="margin-bottom: 20px;" @click="onSearch2" :disabled="disabledButton"  >查询</el-button>
        </el-form-item>
        <el-button :class="display_status" class="fr" type="info" plain @click="kai"  >批量操作</el-button>
      </el-form>
    </div>
    <div class="ty-content white " :class="display_status2">
      <div style="margin-top: 20px">
        <el-button @click="toggleSelection()">全选</el-button>
        <el-button @click="toggleSelection1()">取消全选</el-button>
      </div>

      <br />
      <el-table
        ref="table1"
        :data="tableData"
        style="width: 100%"
        id="table"
        :row-key="rowKey"
        :stripe="false"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="selectable" :reserve-selection="true" width="65"> </el-table-column>
        <el-table-column label="客户名称" fixed width="314">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.ke_name.length >= 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div>
                <div class="user-td" style="display: flex;">
                  <div>
                    {{ scope.row.ke_name }}
                    <span
                      v-if="
                        scope.row.type === 2 &&
                          scope.row.remarks !== null"
                      class="corp-text"
                      >@{{ scope.row.remarks.corp_name }}</span
                    >
                    <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                    <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                    <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

                  </div>
                </div>
              </div>
              <span slot="reference" style="color: #303133;">
                <div class="user-td" style="display: flex;" v-if="scope.row.ke_name !== null">
                  <img
                    :src="
                      (scope.row.avatar) ||
                        require('../assets/images/user_avatar2.png')
                    "
                    width="40"
                    style="width:40px;height:40px;"
                  />
                  <div>
                    {{ scope.row.ke_name | ellipsis}}
                    <span
                      v-if="
                        scope.row.type === 2 &&
                          scope.row.remarks !== null"
                      class="corp-text"
                      >@{{ scope.row.remarks.corp_name }}</span
                    >
                    <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                    <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                                        <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

                  </div>
                </div>
              </span>
            </el-popover>
            <div class="user-td" style="display: flex;" v-if="scope.row.ke_name !== null && scope.row.ke_name.length < 10">
              <img
                :src="
                  (scope.row.avatar) ||
                    require('../assets/images/user_avatar2.png')
                "
                width="40"
                style="width:40px;height:40px;"
              />
              <div>
                {{ scope.row.ke_name }}
                <span
                  v-if="
                    scope.row.type === 2 &&
                      scope.row.remarks !== null"
                  class="corp-text"
                  >@{{ scope.row.remarks.corp_name }}</span
                >
                <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

              </div>
            </div>
            <div v-if="scope.row.ke_name === null" style="display:flex; opacity: 0.45">
              <img src="../assets/images/user_avatar2.png" width="40" style="width:40px;height:40px;"/>
              <div>未知客户</div>
              <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

            </div>
          </template>
        </el-table-column>
        <el-table-column label="跟进员工" >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.name && scope.row.name.length > 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div style="display: inline-block;">
                <div :key="item.id" v-for="item in scope.row.customer_staff">
                  <div style="display:flex;width: 100%;margin-bottom: 5px;">
                    <div v-if="item.new_user_status === -1" style="display:flex;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                      <div class="tag" style="line-height: 16px;">离职</div>
                    </div>
                    <div v-if="item.new_user_status === 6" style="display:flex;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                    </div>
                    <div v-else-if="item.new_user_status === 1" style="display:flex;margin-left:3px;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                    </div>
                    <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                    <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
                  </div>
                </div>
              </div>
              <span slot="reference" style="display: flex;">
              <div :key="item.id" v-for="item in scope.row.customer_staff.slice(0, 2)" style="display: flex;">
              <div style="display:flex;margin-right: 8px;">
                <div v-if="item.new_user_status === -1" style="display:flex;">
                  <div style="color: #00000073;" v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                  <div class="tag" style="height: 20px;line-height: 16px;">离职</div>
                </div>

                <div v-if="item.new_user_status === 6" style="display:flex;">

                  <div style="color: #00000073;" v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                </div>
                <div v-else-if="item.new_user_status === 1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                </div>
                <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
              </div>
            </div>
            <span v-if="scope.row.customer_staff.length > 2" style="margin-left: -8px;">...</span>
            </span>
            </el-popover>
            <span v-if="scope.row.name && scope.row.name.length <= 10" style="display: flex;">
            <div :key="item.id" v-for="item in scope.row.customer_staff">
              <div style="display:flex;margin-right: 8px;">
                <div v-if="item.new_user_status === -1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                  <div class="tag" style="height: 20px;line-height: 16px;">离职</div>
                </div>
                <div v-if="item.new_user_status === 6" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                </div>
                <div v-else-if="item.new_user_status === 1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                </div>
                <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
              </div>
            </div>
          </span>
            <div v-if="scope.row.name === ''">-</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="200" fixed="right" min-width="100">
          <template slot="header">
            状态
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.shared_refresh_status == 2">
              <el-switch
                v-model="scope.row.share_status"
                :active-value="1"
                :inactive-value="2"
                active-color="#204A9E"
                @change="getStatus(scope.row)" >
              </el-switch>
            </div>
            <div v-else >
              <el-switch
                v-model="scope.row.share_status"
                :active-value="1"
                :inactive-value="2"
                active-color="#204A9E"
                @change="getStatus(scope.row)"
                :disabled="true"
              >
              </el-switch>
            </div>

          </template>
        </el-table-column>
        <template #empty>
          <el-empty  v-loading="loading"></el-empty>
        </template>
      </el-table>

      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <div class="ty-content white " :class="display_status3">
      <el-table
        ref="table"
        :data="tableData2"
        style="width: 100%"
        id="table"
        :row-key="rowKey"
        :stripe="false"
      >
        <el-table-column label="客户名称" fixed width="314">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.ke_name.length >= 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div>
                <div class="user-td" style="display: flex;">
                  <div>
                    {{ scope.row.ke_name }}
                    <span
                      v-if="
                        scope.row.type === 2 &&
                          scope.row.remarks !== null"
                      class="corp-text"
                    >@{{ scope.row.remarks.corp_name }}</span
                    >
                    <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                    <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                    <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

                  </div>
                </div>
              </div>
              <span slot="reference" style="color: #303133;">
                <div class="user-td" style="display: flex;" v-if="scope.row.ke_name !== null">
                  <img
                    :src="(scope.row.avatar) || require('../assets/images/user_avatar2.png')"
                    width="40"
                    style="width:40px;height:40px;"
                  />
                  <div>
                    {{ scope.row.ke_name | ellipsis}}
                    <span v-if="scope.row.type === 2 &&scope.row.remarks !== null" class="corp-text">
                      @{{ scope.row.remarks.corp_name }}
                    </span>
                    <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                    <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                    <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

                  </div>
                </div>
              </span>
            </el-popover>
            <div class="user-td" style="display: flex;" v-if="scope.row.ke_name !== null && scope.row.ke_name.length < 10">
              <img
                :src="
                  (scope.row.avatar) ||
                    require('../assets/images/user_avatar2.png')
                "
                width="40"
                style="width:40px;height:40px;"
              />
              <div>
                {{ scope.row.ke_name }}
                <span
                  v-if="
                    scope.row.type === 2 &&
                      scope.row.remarks !== null"
                  class="corp-text"
                >@{{ scope.row.remarks.corp_name }}</span
                >
                <span class="wx-text" v-else-if="scope.row.type === 1">@微信</span>
                <span class="wx-text" v-else-if="scope.row.type === 2 && scope.row.remarks === null"></span>
                <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>
              </div>
            </div>
            <div v-if="scope.row.ke_name === null" style="display:flex; opacity: 0.45">
              <img src="../assets/images/user_avatar2.png" width="40" style="width:40px;height:40px;"/>
              <div>未知客户</div>
              <span class="tag" v-if="scope.row.staff_customer_status === 4"  style="height: 20px;line-height: 16px; width: 30px">失效</span>

            </div>

          </template>
        </el-table-column>
        <el-table-column label="跟进员工" >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.name && scope.row.name.length > 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div style="display: inline-block;">
                <div :key="item.id" v-for="item in scope.row.customer_staff">
                  <div style="display:flex;width: 100%;margin-bottom: 5px;">
                    <div v-if="item.new_user_status === -1" style="display:flex;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                      <div class="tag" style="line-height: 16px;">离职</div>
                    </div>
                    <div v-if="item.new_user_status === 6" style="display:flex;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                    </div>
                    <div v-else-if="item.new_user_status === 1" style="display:flex;margin-left:3px;line-height: 19px;">
                      <div v-if="item.staff_name === null" class="adasd"> 未知员工 </div>
                      <div v-else class="adasd"> {{ item.staff_name }} </div>
                    </div>
                    <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                    <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
                  </div>
                </div>
              </div>
              <span slot="reference" style="display: flex;">
              <div :key="item.id" v-for="item in scope.row.customer_staff.slice(0, 2)" style="display: flex;">
              <div style="display:flex;margin-right: 8px;">
                <div v-if="item.new_user_status === -1" style="display:flex;">
                  <div style="color: #00000073;" v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                  <div class="tag" style="height: 20px;line-height: 16px;">离职</div>
                </div>

                <div v-if="item.new_user_status === 6" style="display:flex;">

                  <div style="color: #00000073;" v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                </div>
                <div v-else-if="item.new_user_status === 1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name | ellipsis}} </div>
                </div>
                <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
              </div>
            </div>
            <span v-if="scope.row.customer_staff.length > 2" style="margin-left: -8px;">...</span>
            </span>
            </el-popover>
            <span v-if="scope.row.name && scope.row.name.length <= 10" style="display: flex;">
            <div :key="item.id" v-for="item in scope.row.customer_staff">
              <div style="display:flex;margin-right: 8px;">
                <div v-if="item.new_user_status === -1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                  <div class="tag" style="height: 20px;line-height: 16px;">离职</div>
                </div>
                <div v-if="item.new_user_status === 6" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                </div>
                <div v-else-if="item.new_user_status === 1" style="display:flex;">
                  <div v-if="item.staff_name === null"> 未知员工 </div>
                  <div v-else> {{ item.staff_name }} </div>
                </div>
                <span v-if="item.new_user_session_status === 1" class="tag01" style="line-height: 16px;">存档</span>
                <span v-else-if="item.new_user_session_status === 2" class="tag" style="line-height: 16px;">存档关闭</span>
              </div>
            </div>
          </span>
            <div v-if="scope.row.name === ''">-</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="200" fixed="right" min-width="100">
          <template slot="header">
            状态
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.hui_h_status === 1">
              <el-switch
                v-model="scope.row.share_status"
                :active-value="1"
                :inactive-value="2"
                active-color="#204A9E"
                @change="getStatus(scope.row)" >
              </el-switch>
            </div>
            <div v-else style="opacity: 0.45">不可操作</div>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty  v-loading="loading"></el-empty>
        </template>
      </el-table>

      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange2"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="批量操作"
    :visible.sync="dialogVisible"
    :show-close="false"
    :close-on-click-modal="false"
    width="400px"
    top="17%"
    color="#204A9E">
      <el-radio-group  v-model="radio">
        <el-radio  label="1">开启</el-radio>
        <el-radio label="2">关闭</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="getStatus">确定</el-button>
      </span>
    </el-dialog>

    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              size="small"
              @input="dfhuh"
              @clear="gdfgf"
              clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :check-strictly="true"
              :default-checked-keys="peoples"
              lazy
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.is_user_id === false">
                    <img class="organization-img imgleft" src="../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.is_user_id === true">
                    <img v-if="data.label" class="organization-img imgleft" src="../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    <span>{{ data.label }}</span><span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" style="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>已选择的员工</div>
             <ul class="infinite-list" v-if="checkedDimission.length > 0">
               <li class="cich fsdfs" v-for="item in checkedDimission" :key="item.id" @click="employeeClose(item)">
                <img class="organization-img" src="../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                  <div class="uiwe">
                    <i class="el-icon-close "></i>
                  </div>
                </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-checkbox  v-model="checked2" style="position: absolute;left: 19px;" @change="checkAllStaff">显示离职员工</el-checkbox>
        <el-button type="info" plain @click="closee">取消</el-button>
<!--        <el-button style="width: 72px;" type="primary" :disabled="disabled01" >确定</el-button>-->
        <el-button style="width: 72px;" type="primary" :disabled="disabled01" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>

    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="departmentShow" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>
              <el-input
                class="filter-input"
                placeholder="搜索部门"
                prefix-icon="el-icon-search"
                v-model="filterTexts"
                size="small"
                clearable
              >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <el-tree
              ref="departmentData"
              id="fixtree"
              :data="departmentData"
              node-key="value"
              :props="departmentProps"
              :check-on-click-node="true"
              @check-change="getDepart"
              :default-expanded-keys="departs"
              :default-checked-keys="departs"
              :filter-node-method="filterDepart"
              :check-strictly="true"
            >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>
                  <img src="../../src/assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                  <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                  <span v-if="data.is_show === false">{{ data.label }}</span><span
                      v-if="node.checked"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                </span>
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div class="xuanze">已选择的部门</div>
            <ul class="infinite-list">
              <li v-for="item in checkedDepartment" :key="item.id" @click="empClose(item)">
                <div><img class="organization-img" src="../assets/images/zuzhi.png" style="width:14px;height:14px;" alt=""></div>
                <div :class="item.label.length <= 20 ? 'wq' : 'wq01'"><span>{{ item.label }}</span></div>
                <div><i class="el-icon-close"></i></div>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closeDepart">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2"  @click="reLoadDepart">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
      checkAll: false,
      checkAllData: [],
      display_status: 'disabled2',
      display_status2: 'disabled2',
      display_status3: 'disabled1',
      tabs: [
        {
          title: '可操作',
          auth: 'inheritOff'
        },
        {
          title: '不可操作',
          auth: 'inheritOn'
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'is_user_id'
      },
      parent_id: 0,
      treeData01: [],
      treeData02: [],
      departmentProps: {
        children: 'child',
        label: 'label',
        value: 'value',
        disabled: 'is_show'
      },
      departs: [],
      treeData: [],
      departmentData: [],
      filterText: '',
      filterTexts: '',
      id: [],
      disabled01: true,
      checked2: false,
      depapart_id: [],
      checkedDimission: [],
      checkedDepartment: [],
      departmentShow: false,
      currentPage: 1,
      disabled2: true,
      pagesize: 10,
      tableData: [],
      tableData2: [],
      status: '',
      total: 0,
      disabledButton: false,
      loading: false,
      radio: 0,
      user_id: [],
      newArr: [],
      arr: [],
      arrs: [],
      arre: [],
      ke_name: '',
      chooseNode: {},
      disable: false,
      disable01: false,
      multipleSelection: [],
      dialogVisible: false,
      searchForm: {
        st_user_id: '',
        department_id: '',
        share_status: '1'
      },
      options: [{
          share_status: '1',
          label: '全部'
        }, {
          share_status: '2',
          label: '关闭'
        }, {
          share_status: '3',
          label: '开启'
      }],
      y: [],
      x: [],
      userId: [],
      depart_id: [],
      openTitle: ['会话存档开启中', '会话存档已关闭', '未开通会话存档'],
      isSelectDialog: false,
      staff_peo: '',
      peoples: []
    }
  },
  mounted() {
    this.getList()
    this.sfhusi()
    // this.getDepartment()
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        // this.treeData01 = []
        // this.sfhusi()
      }
    },
    filterTexts(val) {
      if (val) {
        this.$refs.departmentData.filter(val)
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    },
    checkedDepartment(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      if (this.checked2 === false) {
        this.$api.post('/api/v1/test/get-department', {
          user_id: sessionStorage.getItem('user_id'),
          parent_id: this.parent_id
        }).then(res => {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        })
      } else {
        this.$api.post('/api/v1/test/get-department2', {
          user_id: sessionStorage.getItem('user_id'),
          parent_id: this.parent_id
        }).then(res => {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        })
      }
    },
    // 二级
    getChildrenNode() {
      if (this.checked2 === false) {
        this.$api.post('/api/v1/test/get-department', {
          user_id: sessionStorage.getItem('user_id'),
          parent_id: this.parent_id
        }).then(res => {
          if (res.return_data.length === 0) {
            res.return_data = [{ is_user_id: true }]
            this.treeData01 = res.return_data
          } else {
            this.chooseNode = 0
            this.treeData01 = res.return_data
          }
        })
      } else {
        this.$api.post('/api/v1/test/get-department2', {
          user_id: sessionStorage.getItem('user_id'),
          parent_id: this.parent_id
        }).then(res => {
          if (res.return_data.length === 0) {
            res.return_data = [{ is_user_id: true }]
            this.treeData01 = res.return_data
          } else {
            this.chooseNode = 0
            this.treeData01 = res.return_data
          }
        })
      }
    },
    handleSelectionChange(val) {
      var t1 = this.multipleSelection.length
      this.multipleSelection = val
      var t3 = this.multipleSelection.length
      //
      // console.log(this.multipleSelection.length)
      // console.log(t3)
      if (t3 < 1) {
        this.checkAll = false
        this.checkAllData = []
      }
      // if (t1 > t3) {
      //   if (this.checkAll === true) {
      //     this.checkAll = false
      //   }
      // }
    },
    rowKey(row) {
      return row.ke_user_id
    },
    getList() {
      // console.log(this.checkAll)
      this.loading = true
      const { clientName } = this.searchForm
      this.$api
        .get('/api/v1/share/index', {
          page: this.currentPage,
          ke_name: clientName,
          st_user_id: this.id,
          status: this.searchForm.share_status
          // is_all: sessionStorage.getItem('isAll') || 1,
          // user_id: userId
        })
        .then(res => {
          if (res.list.length > 0) {
            let a = []
            for (let i = 0; i < res.list.length; i++) {
              if (res.list[i].customer_staff.length > 0) {
                const e = res.list[i].customer_staff
                for (let j = 0; j < e.length; j++) {
                  a.push(e[j].staff_name)
                }
              }
              res.list[i].name = a.toString()
              a = []
            }
            // for (let u = 0; u < res.list.length; u++ ) {
            //   if (res.list[u].department.length > 0) {
            //     res.list[u].department_name = res.list[u].department.toString()
            //   }
            // }
            this.tableData = res.list
            this.total = res.total
            this.loading = false
            // console.log(this.currentPage)
            // console.log(this.checkAll)
            if (this.checkAll === true) {
              this.checkAll = true
              if (this.checkAllData.indexOf(this.currentPage) === -1) {
                this.checkAllData.push(this.currentPage)
                this.$refs.table1.toggleAllSelection()
              }
            }

            if (res.shared_refresh_status === '1' ) {
              this.$message.warning('数据正在同步中，请稍后查看！')
              // alert(res.shared_refresh_status)
              this.disabledButton = true
            }
          } else {
            this.tableData = res.list
            this.total = res.total
            this.loading = false
          }
        })
    },
    getList2() {
      this.loading = true
      const { clientName } = this.searchForm
      this.$api
        .get('/api/v1/share/index', {
          page: this.currentPage,
          ke_name: clientName,
          st_user_id: this.id,
          status: 4
          // is_all: sessionStorage.getItem('isAll') || 1,
          // user_id: userId
        })
        .then(res => {
          if (res.list.length > 0) {
            let a = []
            for (let i = 0; i < res.list.length; i++) {
              if (res.list[i].customer_staff.length > 0) {
                const e = res.list[i].customer_staff
                for (let j = 0; j < e.length; j++) {
                  a.push(e[j].staff_name)
                }
              }
              res.list[i].name = a.toString()
              a = []
            }
            // for (let u = 0; u < res.list.length; u++ ) {
            //   if (res.list[u].department.length > 0) {
            //     res.list[u].department_name = res.list[u].department.toString()
            //   }
            // }
            this.tableData2 = res.list
            this.total = res.total
            this.loading = false
          } else {
            this.tableData2 = res.list
            this.total = res.total
            this.loading = false
          }
        })
    },
    getStatus(row) {
      if (this.multipleSelection.length === 0) {
        this.x.push(row.ke_user_id)
      }
      for (const item of this.multipleSelection) {
        this.x.push(item.ke_user_id)
      }
      var checkAll = 2
      if (this.checkAll === true) {
         checkAll = 1
      }
      // alert(row.share_status)
      const params = {
        kehu_id: this.x,
        page_data: this.checkAllData,
        type: this.radio,
        is_all: checkAll
      }
      // console.log(this.x)
      this.$api.post('/api/v1/share/edit', params).then((res) => {
      })
      if (row.share_status === 2) {
        this.$message.success('关闭成功！')
      }

      if (row.share_status === 1) {
        this.$message.success('开启成功！')
      }
      // alert(this.radio)
      if (this.radio === '2') {
        this.$message.success('关闭成功！')
      }
      if (this.radio === '1') {
        this.$message.success('开启成功！')
      }
      this.radio = 0
      this.dialogVisible = false
      this.multipleSelection = []
      this.x = []
      this.$refs.table1.clearSelection()
      setTimeout(() => {
        console.log('500ms后执行的方法')
        this.getList()
      }, 1500)

      // location.reload()
      // this.$router.go(0)
    },
    selectable(row, index) {
      if (row.hui_h_status === 2) {
        return false
      } else {
        return true
      }
    },
    changeState(row) {
      const state = row.is_open_status
      this.$confirm(`确定${state ? '关闭' : '开启'}该客户的会话共享吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          const tokenList = []
          const idList = []
          row.user_itme
            .filter(v => v.type === 1)
            .forEach(item => {
              tokenList.push(item.user_token)
              idList.push(item.user_id)
            })

          this.$api
            .post('/api/sharing/setting', {
              user_token_list: tokenList,
              user_id_list: idList,
              kehu_token: row.client.user_token,
              kehu_id: row.client.user_id,
              setting_type: state ? 2 : 1
            })
            .then(() => {
              this.$message({
                message: `${state ? '关闭' : '开启'}成功！`,
                type: 'success'
              })
              this.getList()
            })
        })
        .catch(() => {})
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    onSearch2() {
      this.currentPage = 1
      this.getList2()
    },
    kai() {
      const l = []
      if (this.multipleSelection.length === 0) {
        this.dialogVisible = false
        this.$message.warning('请选择要共享的客户！')
        return
      }
      if (this.multipleSelection.length > 0) {
        for ( const p of this.multipleSelection) {
          l.push(p.share_status)
        }
        const a = l.every((item) => {
          if (item === 1) {
            return true
          } else {
            return false
          }
        })
        const c = l.every((f) => {
          if (f === 2) {
            return true
          } else {
            return false
          }
        })
        // if (a === true) {
        //   this.dialogVisible = true
        //   this.disable = true
        //   this.disable01 = false
        // } else if (c === true) {
          this.dialogVisible = true
          this.disable01 = true
          this.disable = false
        // }
        // else {
        //   this.$message.warning('请选择相同状态的客户进行批量操作！')
        // }
      }
    },
    close() {
      this.dialogVisible = false
      this.filterText = ''
      // this.treeData02 = []
      // this.checkedDimission = []
      // this.getList()
    },
    employeeClear() {
      this.id = []
      this.filterText = ''
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    currentChange(val) {
      this.tableData = []
      this.currentPage = val
      this.getList()
    },
    currentChange2(val) {
      this.tableData = []
      this.currentPage = val
      this.getList2()
    },
    openSelectDialog() {
      // this.filterText = ''
      this.parent_id = 0
      // this.treeData01 = []
      // this.treeData02 = []
      // this.checkedDimission = []
      this.isSelectDialog = true
      // this.getlistAll()
      // this.loadNode()
    },
     // 获取员工列表
    getlistAll() {
      const params = {
        page: 1,
        limit: 15
      }
      this.$api.get('/api/v1/inherit/get-department-user', params).then(response => {
        let res = response
        if (response && typeof response === 'string') {
          res = JSON.parse(response)
        }

        const treeData = res || []
        treeData.forEach(v => {
          v.checkTitle = v.name
          v.id = v.user_id
        })
        this.treeData = treeData || []
      })
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getChecked(value, isCheck) {
      if (value.is_user_id === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        this.checkedDimission.forEach(v => {
          this.peoples.push(v.id)
        })
        return false
      }
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    empClose(value) {
      this.$refs.departmentData.setChecked(value.value, false)
    },
    reLoadTable() {
      this.id = []
      const p = []
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
          p.push(v.name)
          this.id.push(v.id)
        })
        this.searchForm.st_user_id = p.toString()
        this.currentPage = 1
        // if (this.tabIndex === 1) {
        //   this.getList2()
        // } else {
        //   this.getList()
        // }
        this.isSelectDialog = false
      }
    },
    closee() {
      this.isSelectDialog = false
      this.filterText = ''
      this.searchForm.st_user_id = ''
      this.id = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    checkAllStaff() {
      // this.isSelectDialog = false
      // this.filterText = ''
      // this.searchForm.st_user_id = ''
      // this.id = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      if (this.checked2 === true) {
        this.sfhusi()
      } else {
        this.sfhusi()
      }
    },
    // tree过滤
    filterDepart(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 获取部门表
    // getDepartment() {
    //   this.$api.get('/api/v1/inherit/get-department', {
    //     user_id: sessionStorage.getItem('user_id')
    //   }).then(response => {
    //     let arr = []
    //     arr = response.data
    //     this.departmentData = arr || []
    //   })
    // },
    getDepart(value, isCheck) {
      const checkedDepartment = this.checkedDepartment
      if (isCheck) {
        checkedDepartment.push({
          label: value.label,
          value: value.value
        })
      } else {
        checkedDepartment.forEach((item, i) => {
          if (item.value === value.value) {
            checkedDepartment.splice(i, 1)
          }
        })
      }
      this.checkedDepartment = checkedDepartment
      this.checkedDepartment.forEach(k => {
        this.departs.push(k.id)
      })
    },

    closeDepart() {
      this.searchForm.department_id = ''
      this.departmentShow = false
      this.getDepartment()
      // this.departmentData = []
      this.checkedDepartment = []
    },
    reLoadDepart() {
      const l = []
      if (this.checkedDepartment.length > 0) {
        this.checkedDepartment.forEach(v => {
          l.push(v.label)
          this.depapart_id.push(v.value)
        })
        this.searchForm.department_id = l.toString()
        this.currentPage = 1
        this.departmentShow = false
        this.getList()
      } else {
        this.$message.warning('请先选择部门')
      }
    },
    gdfgf() {
      this.filterText = ''
      this.treeData01 = []
    },
    dfhuh() {
      this.treeData01 = []
      if (this.checked2 === false) {
        this.$api.post('/api/v1/test/get-user-department', {
          user_id: sessionStorage.getItem('user_id'),
          name: this.filterText
        })
          .then(res => {
            if (res.length === 0 || res.user_data.length === 0) {
              this.treeData02 = []
              this.parent_id = 0
              this.sfhusi()
              // this.loadNode()
            } else {
              this.treeData02 = res.user_data
            }
          })
      } else {
        this.$api.post('/api/v1/test/get-user-department2', {
          user_id: sessionStorage.getItem('user_id'),
          name: this.filterText
        })
          .then(res => {
            if (res.length === 0 || res.user_data.length === 0) {
              this.treeData02 = []
              this.parent_id = 0
              this.sfhusi()
              // this.loadNode()
            } else {
              this.treeData02 = res.user_data
            }
          })
      }
    },
    clear() {
       this.parent_id = 0
    },

    tabChange(index) {
      this.tabIndex = index
      this.checkedDimission = []
      if (this.tabIndex === 0) {
        this.searchForm = []
        this.isSelectDialog = false
        this.filterText = ''
        this.searchForm.st_user_id = ''
        this.id = []
        this.treeData01 = []
        this.treeData02 = []
        this.checkedDimission = []
        this.parent_id = 0
        this.sfhusi()
        this.tableData = []
        this.currentPage = 1
        this.display_status = 'disabled2'
        this.display_status2 = 'disabled2'
        this.display_status3 = 'disabled1'
        this.ischange = true
        //  return false
        sessionStorage.setItem('index', this.tabIndex)
        this.getList()
      } else if (this.tabIndex === 1) {
        this.searchForm = []
        this.isSelectDialog = false
        this.filterText = ''
        this.searchForm.st_user_id = ''
        this.id = []
        this.treeData01 = []
        this.treeData02 = []
        this.checkedDimission = []
        this.parent_id = 0
        this.sfhusi()
        this.tableData = []
        this.currentPage = 1
        this.display_status = 'disabled1'
        this.display_status2 = 'disabled1'
        this.display_status3 = 'disabled2'
        this.ischange = true
        sessionStorage.setItem('index', this.tabIndex)
        this.getList2()
      }
    },

    toggleSelection() {
      // this.$refs.table1.clearSelection()
      if (this.checkAll === true ) {
        this.checkAll = false
        this.$refs.table1.clearSelection()
        this.checkAllData = []
        this.multipleSelection = []
        return true
      }
      this.checkAll = true
      if (this.checkAllData.indexOf(this.currentPage) === -1) {
        this.checkAllData.push(this.currentPage)
      }
      this.$refs.table1.toggleAllSelection()
    },
    toggleSelection1() {
      this.checkAll = false
      this.$refs.table1.clearSelection()
      this.checkAllData = []
      this.multipleSelection = []
      //   })
      // } else {
      //   this.$refs.table1.clearSelection()
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.ty-card {
  padding-bottom: 5px;
}
.el-card {
  position: relative;
  // height: 500px;
//  overflow: auto;
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}

.user-td {
  img {
    border-radius: 2px;
    border: 1px solid rgba(32, 74, 158, 0.48);
    vertical-align: middle;
    margin-right: 5px;
  }
}
.user-list {
  display: flex;
  flex-wrap: wrap;

  .user-bg {
    position: relative;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    margin: 5px 0 5px 20px;
    border-radius: 4px;

    .msg-icon {
      position: absolute;
      top: -2px;
      left: -10px;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
    }

    &.normal {
      padding: 0 10px 0 20px;
      background: rgba(4, 29, 52, 0.06);
      .msg-icon {
        color: #c8c8c8;
      }
    }

    &.active {
      padding: 0 10px 0 20px;
      background: rgba(0, 145, 255, 0.1);
      color: #0091ff;
      .msg-icon {
        color: #0091ff;
      }
    }
  }
}
.wx-text {
  color: #46bb36;
}
.corp-text {
  color: #ff9c6e;
}
.badge {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #46bb36;

  &.danger {
    background: #ee2928;
  }
}
::v-deep .el-form-item__label{
  height:auto;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: white;
}
// ::v-deep table tr:nth-child(even) {
//     background: white;
//     border-bottom: 1px solid #D8DCE6;
// }
.el-table__row {
  border-bottom: 1px solid #D8DCE6
}
.el-table__body{
  border-collapse: collapse;
}
.tu{
  width:20px;
  height:20px;
  margin-left:5px;
  margin-top:1px;
}
.tu01{
  width:20px;
  height:20px;
  margin-left:5px;
  margin-top: -1.5px;
}
// ::v-deep .el-icon-close:before {
//   color:#204A9E;
// }
::v-deep .el-dialog .el-dialog__footer {
    text-align: right;
}
::v-deep .el-form-item {
    margin-bottom: 0px;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  display: none;
}
.loading-icon{
  color: #234C9C;
}
::v-deep .el-button--primary.is-disabled{
  opacity: 0.7;
}
::v-deep .el-card__header{
  border-bottom: none;
  box-shadow: none;
}
::v-deep .el-card__body{
  box-shadow: none;
}
.infinite-lists{
  padding: 0;
  margin: 0;
}
.dsfd{
  text-align:left;
  margin-top: 10px;
  margin-left: -20px;
}
::v-deep .el-input{
  position: none;
  top: 0;
  left: 0;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep .el-dialog__body{
  padding: 0;
}
::v-deep .el-radio{
  margin: 30px;
}
::v-deep .el-popover__reference{
  color: #2c3e50;
}
::v-deep .ty-cha{
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.adasd{
  line-height: 19px;
}

::v-deep .ty-card {
  padding: 24px 32px;
  // line-height: 70px;
  padding-bottom: 5px;
  border-radius: 2px;
}

.ty-tab {
  display: flex;

  .tab-item {
    position: relative;
    padding-bottom: 22px;
    transition: all 0.3s;
    cursor: pointer;

    &+.tab-item {
      margin-left: 20px;
    }

    &.active {
      color: #204a9e;
    }

    &.active::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background: #204a9e;
      border-radius: 2px;
    }
  }
}
.ty-tab .tab-item.active{
  font-size: 18px;
  font-weight: 550;
}
::v-deep .ty-tab .tab-item {
  height: 29px;
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 0;
  border-radius: 2px 2px 0px 0px;
}

::v-deep .ty-tab .tab-item.active::after{
  content: "";
  position: absolute;
  top: 54px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #204a9e;
  border-radius: 2px 2px 0px 0px;
}
::v-deep .ty-tab .tab-item:hover{
  color: #204A9E;
}
.disabled1{
  display: none;
}

.disabled3{
  display: none;
}
.dialog-footer {
  //display: flex;
  justify-content: space-between;
}
</style>
